import globalClasses from '../../../App.module.css';

export default function SystemCombinationsDescription() {
    const { DescriptionItem } = globalClasses;

    const systemCombinationsTranslations = {
        startingPrice: 'SP',
        totalOddsNotAvailable: 'N/A',
    };

    return (
        <>
            <p className={DescriptionItem}>
                The <b>system combinations</b> helper returns data needed to
                display different betslip combinations
            </p>
            <p className={DescriptionItem}>
                <b>betErrorsIndexes</b> array contains the indexes that are not
                valid as combinations related to the specific bets
            </p>
            <p className={DescriptionItem}>
                The getSystemCombinations() function can accept a JSON with the
                below parameters.
            </p>
            <ol className={globalClasses.ParamsList}>
                <li>
                    <b>selectedOutcomes </b>
                    <i>
                        an array containing all outcomes selected by the player{' '}
                        <b>*</b>
                    </i>
                </li>
                <li>
                    <b>betErrorsIndexes </b>
                    <i>
                        an array containing contain the indexes that are not
                        valid as combinations related to the specific bets{' '}
                    </i>
                </li>
                <li>
                    <b>translations </b>
                    <i>
                        an object for translations, used to translate some
                        static text and the following
                        <b> keys needs to be added</b> to translations object:
                    </i>
                    <code>
                        <pre>
                            {JSON.stringify(
                                systemCombinationsTranslations,
                                null,
                                4,
                            )}
                        </pre>
                    </code>
                    <p>
                        <i>
                            If the translation object is not provided or a key
                            is missing, it will fallback to the english text.
                        </i>
                    </p>
                </li>
            </ol>
            <p className={DescriptionItem}>
                <i>*required</i>
            </p>
            <div className={DescriptionItem}>
                The function returns an object with two properties:
                <ol>
                    <li>
                        <b>outcomeIds</b>: an array of the selected outcomes ids
                        and odds received as input parameter but with an extra
                        index parameter used to identify the selected outcome in
                        the combinations list
                    </li>
                    <li>
                        <b>combinations</b>: an object with all available
                        combination types for those outcomes grouped by
                        combination type. Each combination type prop is an
                        object containing:{' '}
                        <ul>
                            <li>
                                outcomesIndexes - an array of arrays containing
                                all the possible combinations for that
                                combination type
                            </li>
                            <li>
                                type - either system (for single, double,
                                treble) or package (trixie, patent)
                            </li>
                            <li>
                                totalOdds - an array of total odds corresponding
                                to each combination
                            </li>
                        </ul>
                    </li>
                </ol>
            </div>
        </>
    );
}
